var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-form-input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: _vm.options,
      expression: "options"
    }],
    ref: _vm.label,
    staticClass: "form-control",
    attrs: {
      "id": _vm.label,
      "name": _vm.label,
      "value": _vm.valuePlaceholder,
      "disabled": _vm.disabled
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleEnter.apply(null, arguments);
      },
      "input": _vm.setValue
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };